var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"game-tags"},_vm._l((_vm.tags),function(ref,name){
var games = ref.games;
var hex = ref.hex;
var tagTextColor = ref.tagTextColor;
return (_vm.game && games.includes(_vm.game.id))?_c('tag',{key:name,attrs:{"label":name,"hex":hex,"text-hex":tagTextColor,"readonly":""},on:{"action":_vm.openTags,"close":function($event){return _vm.removeTag(name)}}}):_vm._e()}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-694f0a45","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GameDetail/GameTags.vue
// module id = null
// module chunks = 